<template>
  <div class="dashboard-admin-sidebar-nav-ui">
    <DashboardSidebarContentSection>
      <IconBtn
        class="admin-go-back"
        variation-class-name="admin-go-back"
        prepend-icon-class-name="fr fr-chevron-left"
        label="Back to Opportunities"
        flat
        @click="emitGoBack"
      />
    </DashboardSidebarContentSection>
    <DashboardSidebarSection title="Admin Hub">
      <DashboardSidebarContentSection>
        <ul class="dashboard-admin-sidebar-nav-ui__list">
          <li v-for="link in navLinks" :key="link.to">
            <DashboardSidebarLink :to="link.to" @navigate="emitNavigate">
              {{ link.title }}
            </DashboardSidebarLink>
          </li>
        </ul>
      </DashboardSidebarContentSection>
    </DashboardSidebarSection>
  </div>
</template>

<script setup lang="ts">
  // Types
  import type { RouteLocationNormalizedLoaded } from 'vue-router';
  import type { TNavLink } from '~/modules/dashboard/types';

  // Config
  import { NAV_LINKS } from '~/modules/dashboard/config';

  // Composables
  import { usePermissions } from '~/composables/use-permissions';

  // Components
  import DashboardSidebarSection from '~/modules/dashboard/sidebar/section/DashboardSidebarSection.vue';
  import DashboardSidebarLink from '~/modules/dashboard/sidebar/link/DashboardSidebarLink.vue';
  import DashboardSidebarContentSection from '~/modules/dashboard/sidebar/content-section/DashboardSidebarContentSection.vue';
  import IconBtn from '~/misc/btn/icon/IconBtn.vue';

  const emit = defineEmits<{
    (e: 'navigate', route: RouteLocationNormalizedLoaded | string): void;
    (e: 'go-back'): void;
  }>();

  const { hasPitchPanelPermission, hasUploadDataPermission, isAdmin, isOwner } = usePermissions();

  const navLinks: ComputedRef<TNavLink[]> = computed<TNavLink[]>(() => {
    let links: TNavLink[] = NAV_LINKS;

    if (!isAdmin.value && !isOwner.value) {
      links = links.filter((link: TNavLink) => link.to !== '/admin/roi');
    }

    if (!hasPitchPanelPermission.value) {
      links = links.filter((link: TNavLink) => link.to !== '/admin/talking-points');
    }

    if (!hasUploadDataPermission.value) {
      links = links.filter((link: TNavLink) => link.to !== '/admin/address-imports');
    }

    return links;
  });

  const emitNavigate = (route: RouteLocationNormalizedLoaded | string) => emit('navigate', route);

  const emitGoBack = () => emit('go-back');
</script>
